import { WritableSignal } from "@angular/core";
import { MatDialog, MatDialogRef } from "@angular/material/dialog";

import { AuthService } from "../../../services/authservice";
import { DialogAuthComponent } from "../../dialogs/dialog-auth/dialog-auth";
import { DialogSelfServiceComponent } from "../../dialogs/dialog-selfservice/dialog-selfservice";
import { openSelfServiceDialog } from "../../dialogs/dialog-selfservice/dialog-selfservice.helpers";
import { SelfserviceState, TabbedDetailContainerSubscription } from "./tabbed-detail-container.types";

export function openSelfserviceDialog(
  type: string,
  dialog: MatDialog,
  auth: AuthService,
  service: TabbedDetailContainerSubscription,
  item: any,
  activeTabIndex: number,
  selfserviceState: WritableSignal<SelfserviceState | null>,
  dialogRef: MatDialogRef<DialogSelfServiceComponent<TabbedDetailContainerSubscription>> | undefined,
): MatDialogRef<DialogSelfServiceComponent<TabbedDetailContainerSubscription>> | undefined {
  const state = selfserviceState();
  const selectedPrefix = state?.selectedPrefix ?? "";

  const roleCheckResult = auth.checkRoleAccess(service.product?.type, "edit");
  if (!roleCheckResult.ok) {
    auth.roleEvent.emit(roleCheckResult);
    return undefined;
  }

  if (!auth.selfServiceStarted()) {
    const newState = { activeTabItem: item, activeTabIndex };
    selfserviceState.set(newState);

    dialog.open(DialogAuthComponent, {
      data: {
        state: false,
        initialAction: type,
        selfserviceState: newState,
      },
    });
    return undefined;
  }

  // if dialogRef, reuse old instance
  if (dialogRef !== undefined && dialogRef.componentInstance !== null) {
    dialogRef.componentInstance.subscription.set(service);
    dialogRef.componentInstance.instance = item;
    dialogRef.componentInstance.sapIndex.set(activeTabIndex);
    dialogRef.componentInstance.selectedPrefix = selectedPrefix;
  } else {
    const resolvedTabItem = state?.activeTabItem || item;
    const resolvedTabIndex = state?.activeTabIndex || activeTabIndex;

    dialogRef = openSelfServiceDialog(dialog, {
      type,
      subscription: service,
      instance: resolvedTabItem,
      sapIndex: resolvedTabIndex,
      selectedPrefix,
    });
  }
  selfserviceState.set(null);

  return dialogRef;
}
